import { useEffect, useState } from 'react'

const SLOT_MACHINE_EMOJIS = ['🍌', '🐚', '💣', '🪝', '🚀', '🛡', '⭐', '❄️']

export default function BonusSlot({ bonus, effetActif, effetExpireLe, frozen, onUse, slotMachine }) {
  const [slotEmoji, setSlotEmoji] = useState(null)

  useEffect(() => {
    if (!slotMachine) { setSlotEmoji(null); return }
    let i = 0
    const id = setInterval(() => {
      setSlotEmoji(SLOT_MACHINE_EMOJIS[i % SLOT_MACHINE_EMOJIS.length])
      i++
    }, 80)
    return () => clearInterval(id)
  }, [slotMachine])

  const now   = new Date()
  const effOk = effetActif && effetExpireLe && new Date(effetExpireLe) > now

  const secsLeft = effOk ? Math.ceil((new Date(effetExpireLe) - now) / 1000) : 0

  const displayEmoji = (slotMachine && slotEmoji)
    ? slotEmoji
    : effOk
      ? { shield: '🛡', star: '⭐' }[effetActif] ?? null
      : bonus?.emoji ?? null

  const borderColor = slotMachine
    ? 'border-yellow-300 shadow-[0_0_8px_2px_rgba(250,204,21,0.5)] animate-pulse'
    : effOk
      ? effetActif === 'shield' ? 'border-blue-400 shadow-[0_0_8px_2px_rgba(96,165,250,0.6)]'
      : effetActif === 'star'   ? 'border-yellow-300 shadow-[0_0_8px_2px_rgba(250,204,21,0.6)]'
      : 'border-white/20'
    : bonus ? 'border-white/50 hover:border-white/80 active:scale-95' : 'border-white/20'

  const clickable = !!bonus && !effOk && !frozen && !slotMachine

  return (
    <button
      onClick={clickable ? onUse : undefined}
      disabled={!clickable}
      className={`relative w-11 h-11 rounded-xl border-2 bg-white/5 flex items-center justify-center shrink-0 transition-all
        ${borderColor}
        ${clickable ? 'cursor-pointer' : 'cursor-default'}
      `}
    >
      {displayEmoji
        ? <span className="text-2xl leading-none">{displayEmoji}</span>
        : <span className="text-white/15 text-xl">?</span>
      }
      {effOk && secsLeft > 0 && (
        <span className="absolute -top-2 -right-2 bg-black/70 text-white text-[9px] font-semibold rounded-full w-4 h-4 flex items-center justify-center leading-none">
          {secsLeft}
        </span>
      )}
    </button>
  )
}
